/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React from 'react';
import languages from '../../../constants/translations';
import { handleKeyDownSubmission } from '../../../utils/cs-helpers';

const TimeSlot = ({
  isSelected,
  isDisabled,
  setTimeInfo,
  slotInfo,
  displayTime,
  isOpen,
  remainingSlots,
  language
}) => {
  const handleAppointmentTimeSelection = () => {
    if (isOpen && !isDisabled) {
      setTimeInfo(slotInfo);
    }
  };

  return (
    <div
      className={`time-slot ${isOpen && !isDisabled ? '' : 'disabled'} ${
        isSelected ? 'selected' : ''
      }`}
      style={{
        display: !isOpen || isDisabled || remainingSlots <= 0 ? 'none' : undefined
      }}
      role="button"
      tabIndex="0"
      aria-disabled={!isOpen || isDisabled}
      onClick={handleAppointmentTimeSelection}
      onKeyDown={e => handleKeyDownSubmission(e, handleAppointmentTimeSelection)}
    >
      <div className="time-slot-display">{displayTime}</div>
      <div className="time-slot-availability">
        {remainingSlots} {languages[language]?.timeSlotAvailability || 'left'}
      </div>
    </div>
  );
};

export default React.memo(TimeSlot);
